function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159 163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hexagon-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donor-Portal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "23.53 23.76 0 81.01 22.6 139.29 79.39 163 135.47 137.54 159 80.32 136.66 23.71 79.85 0 23.53 23.76",
    style: {
      fill: "#ffd100",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-2",
    points: "29.47 29.23 8.44 80.51 28.64 132.72 79.4 153.95 129.53 131.15 150.56 79.89 130.59 29.19 79.81 7.95 29.47 29.23",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonWhite);
export default __webpack_public_path__ + "static/media/hexagon-white.28f1b511f4386ac58a5793fb692fcaba.svg";
export { ForwardRef as ReactComponent };